module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-24"
    }
  }, [_c('h2', {
    staticClass: "part"
  }, [_vm._v("PART ONE")]), _vm._v(" "), _c('h2', {
    staticClass: "part1"
  }, [_vm._v("ETHICS AT WORK")])]), _c('div', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "VPS-24"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The news at the grocery store is grim for many. According to the U.S. Department of Agriculture, food prices rose by 4 percent last year [2007], the largest increase in seventeen years. And the USDA predicts they will rise another 4 percent this year. Eggs are up 40 percent in the past year; milk up 26 percent a gallon; a loaf of standard bread, 20 percent.")])]), _c('p', {
    staticClass: "N"
  }, [_c('a', {
    attrs: {
      "id": "VPS-24"
    }
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bill Moyers Journal")]), _vm._v(", “Hunger in America,” April 11, 2008"), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/025_Endnotes#e6",
      "id": "d6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A lot of food passed through Ned’s hands over the course of a week at work—if not directly through his hands, then under his watch. And some of the “product” that didn’t quite pass muster didn’t go back to the company that produced it, as regulated; it was detoured to low-wage employees. In 2003, Ned said, “There’s always some product that gets damaged, like the packaging or [cans] get dented coming off the truck. And there’s the stuff that comes in, you know, fresh produce, that’s probably not going to pass. … I guess you could say I make the most of that. I make the most of it. I don’t see it as a scam. It’s not for me, it’s for them. … At the end of the month … that’s all they have.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Work is a core class intersection in American life because, every day, millions of low-wage and middle-income people come together to do their jobs. They often get to know each other, their family concerns, hopes, and plans, and in this research clearly "), _c('a', {
    attrs: {
      "id": "VPS-25"
    }
  }, [_vm._v(" some employers got to know their employees pretty well. Of course, some did not; some said they had no interest in low-wage workers and others said that low-wage people have only themselves to blame for being poor. But most employers thought that working people should get a fair day’s pay and be able to keep their families fed and housed. A few went beyond concern, like Ned in the quote above. They found a little opening, a little chink in the system, and used it to treat working people better. Part 1 explores the range of views, judgments, and moral choices among employers.")])]), _c('a', {
    attrs: {
      "id": "VPS-25"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fc8ce46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/010_Chapter_1.vue
// module id = 78
// module chunks = 0